// Single source of truth for the scoring invariants the frontend renders
// against. Previously redefined as a bare CALL_SIGNAL_MIN/CALL_STRONG_MIN/
// PUT_SIGNAL_MAX triple three separate times (PriceChart.js, ScoreChart.js,
// StockDetail.js) plus 9 more files inlining 70/75/25/30 directly.
//
// CLAUDE.md invariant: the *signal* cut (call/put opportunity) is narrower
// than the *assessment bucket* edge (coloring/labeling) — never conflate
// them. The old "CALL_SIGNAL_MIN = 70" name was itself the bug: 70 is the
// bucket edge, not the signal cut.
export const CALL_SIGNAL_MIN = 75; // call opportunity cut (Score.overall >= 75)
export const CALL_BUCKET_MIN = 70; // assessment bucket edge (>= 70)
export const PUT_SIGNAL_MAX = 25;  // put opportunity cut (Score.overall <= 25)
export const PUT_BUCKET_MAX = 30;  // assessment bucket edge (<= 30)
